'use strict';

const jQuery = require('jquery');

const Mediator = require('./../../../core/mediator');

const SaveManager = require('./../component/SaveManager');
const menuMobile = require('./../../../services/structure/menu/mobile');
const Loader = require('./../../../services/loader');
const Uploader = require('./../service/uploader');
const Dropzone = require('./../service/dropzone');
const PluginUpload = require('./../plugin/upload');

module.exports.beforeUpload = function(data) {
    if (data.config.content && data.config.content.$) {
        menuMobile.close();
        Loader.start(data.config.content.$, 'center');
    }
};

module.exports.beforeRenderMenuItem = function(item) {
    if (item.key === 'choose-image-content') {
        let content = item.params.content;
        let $input = Dropzone.createInput({
            'accepted_files': content.getProperties('accepted_files'),
            'onChange': function(file) {
                Uploader.upload(file, {content}).done(function(response) {
                    PluginUpload.updateFileOfMedia(content, response).done(() => {
                        SaveManager.save().done(() => {
                            content.refresh().done(() => {
                                Mediator.publish('after:upload', content);
                                Loader.stop(content.$);
                            });
                        });
                    });
                });
            },
        });

        $input.addClass('d-none');

        item.publish = false;
        item.html = jQuery('<li><label class="btn"><span><i class="icon icon-image"></i><span class="cloud-label">' + item.name + '</span></span></label></li>');

        item.html.find('label').append($input);
    }
};
